function createPurchaseOptionsSelect() {
    const container = document.querySelector(".main-product__purchase-options-body");
    if (!container) return;

    // Criar o novo elemento a ser inserido
    const wrapper = document.createElement("div");
    wrapper.classList.add("main-product__purchase-option-wrapper", "show", "active");
    wrapper.id = "rc-option-subsave";
    wrapper.setAttribute("data-purchase-option-wrapper", "");
    
    wrapper.innerHTML = `
        <div class="main-product__purchase-option">
            <div class="main-product__purchase-option-control radio">
                <input type="radio" name="purchase_option" class="visually-hidden" id="Product-Purchase-Option-Subsave" data-purchase-option="">
                <label for="Product-Purchase-Option-Subsave" class="main-product__purchase-option-label p2 p2--fixed regular">Subscribe and Save</label>
            </div>
            <div class="main-product__purchase-option-meta">
                <span class="main-product__purchase-option-price p2 p2--fixed medium"></span>
            </div>
        </div>
        <div class="main-product__purchase-option-middle">
          Cancel anytime
        </div>
        <div class="main-product__purchase-option-bottom">
          <label>Frequency</label>
          <div class="main-product__purchase-option-bottom_select-wrapper"></div>
          <a href="#">Which frequency is right for me?</a>
        </div>
    `;
    
    // Criar o select
    const select = document.createElement("select");
    select.id = "custom-subsave-select";
    
    // Buscar todas as opções de compra, excluindo o primeiro label
    const options = container.querySelectorAll(".main-product__purchase-option .main-product__purchase-option-label");
    
    options.forEach((option, index) => {
        if (index === 0) return; // Ignorar o primeiro label

        const text = option.textContent.trim();
        const value = option.getAttribute("for"); // Pegando o ID do input relacionado
        
        if (text && value) {
            const optionElement = document.createElement("option");
            optionElement.value = value;
            optionElement.textContent = text;
            select.appendChild(optionElement);
        }
    });
    
    // Inserir o wrapper no começo do container
    container.prepend(wrapper);
  
    // Adicionar o select dentro do wrapper
    wrapper.querySelector('.main-product__purchase-option-bottom_select-wrapper').appendChild(select);
}

function setActive() {
  const options = document.querySelectorAll(".main-product__purchase-option-wrapper.show");

  console.log('options')
  console.log(options)

  options.forEach(option => {
    option.addEventListener('click', function() {
      const optionActive = document.querySelector(".main-product__purchase-option-wrapper.show.active");

      if (optionActive) {
        optionActive.classList.remove('active');
      }
      option.classList.add('active');
    });
  });
}

function showOnetime() {
  const onetimeOption = document.querySelectorAll(".main-product__purchase-options-body .main-product__purchase-option-wrapper")[1]
    
  if (onetimeOption) {
    onetimeOption.classList.add("show");
    onetimeOption.id = "rc-option-onetime";
  }
}

function updateSubsaveLabel() {
    const labelElement = document.querySelector("#rc-option-subsave .main-product__purchase-option-label");
    if (!labelElement) return;

    const observer = new MutationObserver((mutations, obs) => {
        const discountElement = document.querySelector(".rc-option__subsave .rc-option__discount");
        if (discountElement) {
            const discountText = discountElement.textContent.trim();
            labelElement.textContent += ` ${discountText}`;
            obs.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

function updateSubsavePrice() {
    const priceElement = document.querySelector("#rc-option-subsave .main-product__purchase-option-price");
    if (!priceElement) return;

    const observer = new MutationObserver((mutations, obs) => {
        const priceSourceElement = document.querySelector(".rc_widget__price--subsave");
        if (priceSourceElement) {
            setTimeout(function() {
              const priceText = priceSourceElement.innerText;
              priceElement.textContent = priceText;
            }, 100);
            obs.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

function getSubsaveOptionChange() {
  const customSelect = document.querySelector("#custom-subsave-select");
  if (!customSelect) return;

  const observer = new MutationObserver((mutations, obs) => {
    const defaultSelect = document.querySelector(".rc_widget__option__plans__dropdown");
    if (defaultSelect) {
      customSelect.addEventListener('change', function() {
        setTimeout(function(){
          document.getElementById(customSelect.value).click();
        }, 500);
      });
      obs.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

/*
document.addEventListener("DOMContentLoaded", function () {
  createPurchaseOptionsSelect();
  showOnetime();
  setActive();
  updateSubsaveLabel();
  updateSubsavePrice();
  getSubsaveOptionChange();
});
*/